import { useEffect, useRef } from "react";
import { useGatheringStore } from "src/contexts/GatheringContext";
import useRouter from "src/hooks/useRouter";
import usePhotoDetailStore from "../../stores/usePhotoDetailStore";

const useUpdateUrlState = () => {
	const router = useRouter();
	const identifier = useGatheringStore((state) => state.identifier);
	const identifierRef = useRef(identifier);
	useEffect(() => {
		identifierRef.current = identifier;
	}, [identifier]);

	useEffect(() => {
		const unsub = usePhotoDetailStore.subscribe(
			(state) => state.debouncedCurPhoto,
			(debouncedCurPhoto) => {
				if (debouncedCurPhoto) {
					router.replaceState(`/album/${identifierRef.current}`, {
						forwardParams: true,
						params: {
							photo: debouncedCurPhoto.photoId,
						},
					});
				}
			},
		);
		return () => {
			unsub();
		};
	}, [router]);
};
export default useUpdateUrlState;
